import { createRouter, createWebHistory } from 'vue-router';

import Home from '../views/Home.vue';
import vwRegister from '../views/login/register.vue';
import vwCtaCte from '../views/iosepsalud/ctacte.vue';
import vwGlobal from '../views/iosepsalud/global.vue';
import vwPagos from '../views/iosepsalud/pagos.vue';
import vwEmpresa from '../views/iosepsalud/empresas.vue';
import vwNotaCredito from '../views/iosepsalud/notaCredito.vue';
import vwVencimientoFacturacion from '../views/iosepsalud/vencimientosPeriodosFacturacion.vue';
import vwAfiliadosXEmpresa from '../views/iosepsalud/revisarAfiliados.vue';
import ListSituaciones from '../views/stock/situaciones.vue';
import ListMovimientos from '../views/stock/movimientos.vue';
import ListPagos from '../views/pagos/list.vue';
import ListVentas from '../views/ventas/list.vue';
import AiCarga from '../views/ai/cargar.vue';
import DashboardArtritis from '../views/DashboardArtritis.vue';
import PathNotFound from '../layouts/notfound.vue';


import boleta from '../views/autogestion/boleta.vue';

import Cookies from 'js-cookie'
import { DASHBOARD_AR_ROLES, hasAnyRequiredRole } from '@/services/authRoles';

const meta = { auth: true }
const routes = [
  {
    path: '/',
    component: () => import(`@/layouts/default.vue`),
    meta,
    children: [
      {
        path: '',
        name: 'Home',
        component: Home,
        meta,
      },
      {
        path: 'empresaAfil/:idEmpresa',
        name: 'Revisar Afiliados',
        component: vwAfiliadosXEmpresa,
        meta,
      },
      {
        path: 'about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
        meta,
      },
      {
        path: 'ctacte',
        name: 'CtaCte',
        component: vwCtaCte,
        meta,
      },
      {
        path: 'global',
        name: 'Global',
        component: vwGlobal,
        meta,
      },
      {
        path: 'pagos',
        name: 'Pagos',
        component: vwPagos,
        meta,
      },
      {
        path: 'notacredito',
        name: 'Notacredito',
        component: vwNotaCredito,
        meta,
      },
      {
        path: 'vencimientosperiodosfacturacion',
        name: 'VencimientoFacturacion',
        component: vwVencimientoFacturacion,
        meta,
      },
      {
        path: 'register',
        name: 'Register',
        component: vwRegister,
        meta,
      },
      {
        path: 'empresas',
        name: 'Empresas',
        component: vwEmpresa,
        meta,
      },
      {
        path: 'movimientos',
        name: 'Movimientos',
        component: ListMovimientos,
        meta,
      },
      {
        path: 'formaspagos',
        name: 'FormasPagos',
        component: ListPagos,
        meta,
      },
      {
        path: 'ventas',
        name: 'Ventas',
        component: ListVentas,
        meta,
      },
      {
        path: 'ai',
        name: 'AI',
        component: AiCarga,
        meta,
      },
      {
        path: 'dashboard/inicio',
        alias: ['/DashboardArtritis', '/dashboardartritis'],
        name: 'DashboardArtritis',
        component: DashboardArtritis,
        meta: { ...meta, roles: DASHBOARD_AR_ROLES },
      },
      
      { path: ':pathMatch(.*)*', component: PathNotFound },
    ]
  },
  {
    component: () => import(`@/layouts/empty.vue`),
    path: '/',
    children: [
      {
        path: 'login',
        name: 'Login',
        components: {
          empty: () => import(`@/views/login/login.vue`)
        },
        meta: {
          auth: false
        },
      },
    ]
  },

  {
    component: () => import(`@/layouts/empty.vue`),
    path: '/autogestion',
    children: [
      {
        path: 'boleta',
        name: 'Boleta',
        components: {
          empty: () => import(`@/views/autogestion/boleta.vue`)
        },
        meta: {
          auth: false
        },
      },
    ]
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  document.title = `Iosep Salud - ${ to.name }`;
    // document.title = `${ process.env.VUE_APP_TITLE } - ${ to.name }`;
    if (to.matched.some(r => r.meta.auth)  && !to.path.includes("autogestion")) {
        const token = Cookies.get('token');
        if (token && token !== 'undefined' && token.length > 0) {
            const protectedRoute = to.matched.find((r) => r.meta && r.meta.roles);
            if (protectedRoute && !hasAnyRequiredRole(protectedRoute.meta.roles)) {
              next({ name: 'Home' });
              return;
            }
            next()
        } else {
            next({ name: 'Login' })
        }
    } else {
        next()
    }
})

export default router;
